import React, { useEffect, useRef, useState } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-easybutton';
import  'leaflet-svg-shape-markers'
// import 'leaflet-geoserver-request';
// import { Map, TileLayer, WMSTileLayer} from 'react-leaflet'
import Login from "../Login/Login";
import useToken from "../App/useToken";
// import greenIcon from '../../static/icons/triangle_green_10x12px.gif';
// import blueIcon from '../../static/icons/triangle_blue_10x12px.gif';
// import orangeIcon from '../../static/icons/triangle_orange_10x12px.gif';
// import purpleIcon from '../../static/icons/triangle_purple_10x12px.gif';
// import redIcon from '../../static/icons/triangle_red_10x12px.gif';
// import CustomPopup from "../CustomPopup/CustomPopup";
// import CustomMarker from "../CustomMarker/CustomMarker";

const GEODATA_GENERIC_URL = '/geoserver/tsp-iot-maps/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=tsp-iot-maps:all_partners';
const GEODATA_URL_JSON = GEODATA_GENERIC_URL + '&outputFormat=application/json';
const GEODATA_URL_CSV = GEODATA_GENERIC_URL + '&outputFormat=application/text';
// const GEODATA_URL = '/api/data?outputFormat=application';
//const TsunamiMap = ({ ingvData, noaData, koeriData, cenaltData, ipmaData }) => {
const TsunamiMap = () => {
    const { token, setToken, clearToken } = useToken();

    // const global_url= GEODATA_URL;


    const [map, setMap] = useState(null);
    const [layerControl, setLayerControl] = useState(null);
    const [zoomControl, setZoomControl] = useState(null);
    const [ingvLayer, setIngvLayer] = useState(null);
    const [noaLayer, setNoaLayer] = useState(null);
    const [koeriLayer, setKoeriLayer] = useState(null);
    const [cenaltLayer, setCenaltLayer] = useState(null);
    const [ipmaLayer, setIpmaLayer] = useState(null);

    // Map refs:
    const mapRef = useRef(null);
    const tileRef = useRef(null);
    const layerControlRef = useRef(null);
    const zoomControlRef = useRef(null);
    const ingvLayerRef = useRef(null);
    const noaLayerRef = useRef(null);
    const koeriLayerRef = useRef(null);
    const cenaltLayerRef = useRef(null);
    const ipmaLayerRef = useRef(null);

/*
    function GetIcon(_icon, _iconsize) {
        return L.icon({
            iconUrl: _icon,
            iconSize: [_iconsize]
        })
    }
*/

    // get geojson of a single Forecat Point
    function bus(id, name, format){
        // var base_url=global_url + "&CQL_FILTER=id='" + id + "'";
        var base_url;
        var ext;
        if (format === 'json') {
            base_url = `${GEODATA_URL_JSON}&CQL_FILTER=id='${id}'`;
            ext = 'json';
        }
        else if (format === 'text') {
            base_url = `${GEODATA_URL_CSV}&CQL_FILTER=id='${id}'`;
            ext = 'csv';
        }
        fetch(base_url)
            .then(response => {
                response.blob().then(blob => {
                    let url = window.URL.createObjectURL(blob);
                    let a = document.createElement('a');
                    a.href = url;
                    a.download = name.trim() + '.' + ext;
                    a.click();
                });
                //window.location.href = response.url;
            });
    }

    L.thorsten={};
    L.thorsten.bus = bus;

    function SetData(_data, marker_color, _layer) {
        if (_layer) {
            _layer.clearLayers();
            Array.from(_data.features).forEach((feature) => {
                var popupContent = '<div><button onclick="L.thorsten.bus(' + feature.properties["id"] + ',\'' + feature.properties["name"] + '\', \'json\')">download json</button></div>';
                popupContent += '<div><button onclick="L.thorsten.bus(' + feature.properties["id"] + ',\'' + feature.properties["name"] + '\', \'text\')">download csv</button></div>';
                for (var key in feature.properties) {
                    if (feature.properties.hasOwnProperty(key)) {

                        popupContent += "<h3>" + key + ": " + feature.properties[key] + "</h3>"

                    }
                }
                // L.marker([feature.geometry.coordinates[1], feature.geometry.coordinates[0]], {icon: GetIcon(_icon, 13)}).addTo(_layer).bindPopup(popupContent);
                // L.SVG.marker([feature.geometry.coordinates[1], feature.geometry.coordinates[0]], {shape: "triangle"}).addTo(_layer).bindPopup(popupContent);

                L.shapeMarker([feature.geometry.coordinates[1], feature.geometry.coordinates[0]], {
                    fillColor: "#cccccc",
                    color: marker_color,
                    shape: "triangle",
                    radius: 4
                }).addTo(_layer).bindPopup(popupContent);
            });
        }
    }

    tileRef.current = L.tileLayer(
        "http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}",
        {
            maxZoom: 30,
            subdomains: ["mt0", "mt1", "mt2", "mt3"]
        }
    );

    const mapStyles = {
        overflow: 'hidden',
        width: '100%',
        height: '100%',
    };

    // Options for our map instance:
    const mapParams = {
        // center: [37.0902, -95.7129], // USA
        center: [43, 12.4818], // Italy
        zoom: 5,
        zoomControl: false,
        zoomSnap: 0.1,
        zoomDelta: 0.3,
        // wheelPxPerZoomLevel: 1,
        // wheelDebounceTime: 1,
        maxBounds: L.latLngBounds(L.latLng(-150, -240), L.latLng(150, 240)),
        closePopupOnClick: false,
        layers: [tileRef.current], // Start with just the base layer
    };

    // Create a baseMaps object to be passed to the layerControl:
    // const baseMaps = {};

    // Map creation:
    useEffect(() => {
        mapRef.current = L.map('map', mapParams);
        // Set map instance to state:
        setMap(mapRef.current);
    }, []);

    // legend:
    useEffect(() => {
        if (!map) return;
        if (map) {
            var legend = L.control({position: 'bottomright'});

            legend.onAdd = function (map) {

                var div = L.DomUtil.create('div', 'info legend');
                div.innerHTML += '<i style="background:#030374"></i>INGV<br />';
                div.innerHTML += '<i style="background:#097507"></i>NOA<br />';
                div.innerHTML += '<i style="background:#EAA609"></i>KOERI<br />';
                div.innerHTML += '<i style="background:#FF0C09"></i>CENALT<br />';
                div.innerHTML += '<i style="background:#FF42FF"></i>IPMA';

                // var div = L.DomUtil.create('div', 'info legend');
                // div.innerHTML += ""
                return div;
            };

            legend.addTo(map);
        }
    }, [map]);



    // Controls:
    useEffect(() => {
        if (!map) return;
        if (map) {
            L.control.scale().addTo(map);

            // Add the base layer to the control:
            layerControlRef.current = L.control
                .layers({
                    // OpenStreetMap: tileRef.current,
                })
                .addTo(map);

            // Add zoomControl:
            zoomControlRef.current = L.control
                .zoom({
                    position: 'topright',
                })
                .addTo(map);

            setLayerControl(layerControlRef.current);
            setZoomControl(zoomControlRef.current);
        }
    }, [map]);

    // Map events:
    useEffect(() => {
        if (!map) return;
        if (map) {
            map.on('zoomstart', () => {
                console.log('ZOOM STARTED');
                console.log(map.getZoom());
            });
        }
    }, [map]);



    // Create the layerGroup:
    useEffect(() => {
        if (!map) return;
        if (map) {
            if (layerControl) {
                ingvLayerRef.current = L.layerGroup().addTo(map);
                setIngvLayer(ingvLayerRef.current);

                noaLayerRef.current = L.layerGroup().addTo(map);
                setNoaLayer(noaLayerRef.current);

                koeriLayerRef.current = L.layerGroup().addTo(map);
                setKoeriLayer(koeriLayerRef.current);

                cenaltLayerRef.current = L.layerGroup().addTo(map);
                setCenaltLayer(cenaltLayerRef.current);

                ipmaLayerRef.current = L.layerGroup().addTo(map);
                setIpmaLayer(ipmaLayerRef.current);

            }
        }
    }, [map, layerControl]);


    // Add INGV layer to the layer control:
    useEffect(() => {
        if (!map) return;
        if (map) {
            if (layerControl && ingvLayer) {
                layerControl.addOverlay(ingvLayer, 'INGV');
            }
        }
    }, [map, layerControl, ingvLayer]);

    // Add the INGV markers to the map:
    useEffect(() => {
        if (!map) return;
        if (map) {
            const fetch_url=`${GEODATA_URL_JSON}&CQL_FILTER=tsp='INGV'`
            console.log(`DEBUG. URL=${fetch_url}`);
            fetch(fetch_url)
                .then(res => res.json())
                .then((data) => {
                    SetData(data, "#030374", ingvLayer)
                })
            .catch(console.log)
        }
    }, [map, ingvLayer]);

    // Add the INGV markers to the map:
    useEffect(() => {
        if (!map) return;
        if (map) {
            if (layerControl && noaLayer) {
                layerControl.addOverlay(noaLayer, 'NOA');
            }
        }
    }, [map, layerControl, noaLayer]);

    // Add the NOA markers to the map:
    useEffect(() => {
        if (!map) return;
        if (map) {
            const fetch_url=`${GEODATA_URL_JSON}&CQL_FILTER=tsp='NOA'`
            fetch(fetch_url)
                .then(res => res.json())
                .then((data) => {
                    SetData(data, "#097507", noaLayer)
                })
                .catch(console.log)
            // SetData_old(noaData, greenIcon, noaLayer)
        }
    }, [map, noaLayer]);

    // Add KOERI layer to the layer control:
    useEffect(() => {
        if (!map) return;
        if (map) {
            if (layerControl && koeriLayer) {
                layerControl.addOverlay(koeriLayer, 'KOERI');
            }
        }
    }, [map, layerControl, koeriLayer]);

    // Add the KOERI markers to the map:
    useEffect(() => {
        if (!map) return;
        if (map) {
            const fetch_url=`${GEODATA_URL_JSON}&CQL_FILTER=tsp='KOERI'`
            fetch(fetch_url)
                .then(res => res.json())
                .then((data) => {
                    SetData(data, "#EAA609", koeriLayer)
                })
                .catch(console.log)
            // SetData_old(koeriData, orangeIcon, koeriLayer)
        }
    }, [map, koeriLayer]);

    // Add CENALT layer to the layer control:
    useEffect(() => {
        if (!map) return;
        if (map) {
            if (layerControl && cenaltLayer) {
                layerControl.addOverlay(cenaltLayer, 'CENALT');
            }
        }
    }, [map, layerControl, cenaltLayer]);

    // Add the CENALT markers to the map:
    useEffect(() => {
        if (!map) return;
        if (map) {
            const fetch_url=`${GEODATA_URL_JSON}&CQL_FILTER=tsp='CENALT'`
            fetch(fetch_url)
                .then(res => res.json())
                .then((data) => {
                    SetData(data, "#FF0C09", cenaltLayer)
                })
                .catch(console.log)
            // SetData_old(cenaltData, redIcon, cenaltLayer)
        }
    }, [map, cenaltLayer]);

    // Add IPMA layer to the layer control:
    useEffect(() => {
        if (!map) return;
        if (map) {
            if (layerControl && ipmaLayer) {
                layerControl.addOverlay(ipmaLayer, 'IPMA');
            }
        }
    }, [map, layerControl, ipmaLayer]);

    // Add the IPMA markers to the map:
    useEffect(() => {
        if (!map) return;
        if (map) {
            const fetch_url=`${GEODATA_URL_JSON}&CQL_FILTER=tsp='IPMA'`

            fetch(fetch_url)
                .then(res => res.json())
                .then((data) => {
                    SetData(data, "#FF42FF", ipmaLayer)
                })
                .catch(console.log)
            // SetData_old(ipmaData, purpleIcon, ipmaLayer)
        }
    }, [map, ipmaLayer]);

    useEffect(() => {
        if (!map) return;
        L.easyButton('<span class="anticon-star">logout</span>', function () {
            clearToken();
            window.location.reload();
        }).addTo(map);
    }, [map]);

    useEffect(() => {
        if (!map) return;
        L.easyButton('<span class="anticon-star">download json</span>', function () {
            fetch(GEODATA_URL_JSON)
                .then(response => {
                    response.blob().then(blob => {
                        let url = window.URL.createObjectURL(blob);
                        let a = document.createElement('a');
                        a.href = url;
                        a.download = 'all_partners.geojson';
                        a.click();
                    });
                    //window.location.href = response.url;
                });
        }).addTo(map);
    }, [map]);

    useEffect(() => {
        if (!map) return;
        L.easyButton('<span class="anticon-star">download csv</span>', function () {
            fetch(GEODATA_URL_CSV)
                .then(response => {
                    response.blob().then(blob => {
                        let url = window.URL.createObjectURL(blob);
                        let a = document.createElement('a');
                        a.href = url;
                        a.download = 'all_partners.csv';
                        a.click();
                    });
                    //window.location.href = response.url;
                });
        }).addTo(map);
    }, [map]);

    if(!token) {
        return <Login setToken={setToken} />
    }

    return (
        <>
            <div id="map" style={mapStyles}/>
        </>
    );
};

export default TsunamiMap;
